import React from "react";
import { useTable, useSortBy } from "react-table";
import { useSelector } from "react-redux";
import moment from "moment";
import { Button } from "react-bootstrap";
import { UpArrow, DownArrow, DefaultArrow } from "../sortArrows";

const DrugTestsTab = () => {
  const state = useSelector((state) => {
    return {
      organizationName: state.organization.name,
      residentId: state.resident.id,
      drugTests: state.drug_tests,
    }
  });

  const columns = React.useMemo(()=>[
    {
      Header: "Type",
      id: "kind",
      accessor: (row) => row.kind.toLowerCase(),
      Cell: ({ cell: { row: { original } } }) => (
        <a href={original.asset_url} target="_blank">{original.kind}</a>
      )
    }, 
    {
      Header: "Performed At",
      id: "performed_at",
      accessor: (row) => row.created_at.toLowerCase(),
      Cell: ({cell:{row:{original:{performed_at}}}}) => !!performed_at ? moment(performed_at).format("lll") : 'n/a'
    },
    {
      Header: "Result",
      id: "result",
      accessor: (row) => !!row.result ? row.result.toLowerCase() : '',
      Cell: ({ cell: { row: { original } } }) => original.result
    },
    {
      Header: "Created At",
      id: "created_at",
      accessor: (row) => row.created_at.toLowerCase(),
      Cell: ({ cell: { row: { original } } }) => moment(original.created_at).format("lll")
    },
    {
      Header: "Client Signature",
      id: "client_signature",
      Cell: ({ cell: { row: { original } } }) => original.resident_signature_url !== "/resident_signatures/original/missing.png" && <img src={original.resident_signature_url} style={{ height: 50 }} />
    },
    {
      Header: "Staff Signature",
      id: "staff_signature",
      Cell: ({ cell: { row: { original } } }) => original.staff_signature_url !== "/staff_signatures/original/missing.png" && <img src={original.staff_signature_url} style={{ height: 50 }} />
    },
  ],[state.drugTests])

  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data: state.drugTests,
  }, useSortBy);

  return (
    <>
      <table {...getTableProps()} className="table table-responsive">
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted ? (column.isSortedDesc ? <DownArrow /> : <UpArrow />) : <DefaultArrow />}
                  </span>
                </th>
              ))}
              <th />
            </tr>
          ))}
        </thead>
        <tbody>
          {rows.map(
            (row, i) =>
              prepareRow(row) || (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  })}
                </tr>
              )
          )}
        </tbody>
      </table>
      <div className="d-flex flex-row-reverse">
        <Button
          variant="link"
          href={`/organizations/${state.organizationName}/residents/${state.residentId}/drug_tests?q%5Bresident_id_eq%5D=${state.residentId}`}>
          View More
        </Button>
      </div>
  </>
  )
}

export default DrugTestsTab